// CMS 메뉴 관리 페이지(/console/site/cms/menus) 의 per-page dispatch 엔트리.
// 실제 인터랙션(메뉴 트리 드래그·항목 모달·AJAX 폼)은 AdminLayout 의 전역 init
// (initCmsMenuTree / initCmsFormModal / initCmsContentSort / initCmsSiteBuilder) 이
// 셀렉터 기반으로 처리한다. 따라서 여기는 dispatch 경고만 제거하는 빈 스텁이다
// (AdminMenuCategoryController 와 동일 패턴).
export const AdminCmsMenuController = {
    index(): void {},
    store(): void {},
    update(): void {},
    destroy(): void {},
    reorder(): void {},
};
